<template>
  <el-menu
    class="el-menu-demo"
    mode="horizontal"
    background-color="#334157"
    text-color="#fff"
    active-text-color="#fff"
  >
    <el-button class="buttonimg">
      <img
        class="showimg"
        :src="collapsed ? imgsq : imgshow"
        @click="toggle(collapsed)"
      />
    </el-button>
    <div class="layoutRight">
<!--      <el-button size="small" type="info" @click="handleCaptureTicket">-->
<!--        抓票-->
<!--      </el-button>-->
      <!-- 消息中心 -->
      <div class="btn-info">
        <el-tooltip placement="bottom">
<!--          <span slot="content">{{message ? `有${message}条消息` : '消息中心'}}</span>-->
          <span slot="content">请点击进入预警消息</span>
          <router-link :to="{ path: '/system/warn' }">
            <i class="el-icon-bell" v-if="message > 0" style="color: red"></i>
            <i class="el-icon-bell" v-else style="color: white"></i>
          </router-link>
        </el-tooltip>

      </div>
      <span class="btn-info-tip" v-if="message"></span>
      <el-submenu index="2" class="submenu">
        <template slot="title">{{ user["realName"] }}</template>
        <el-menu-item @click="handleExit()" index="2-3">退出</el-menu-item>
      </el-submenu>
    </div>
  </el-menu>
</template>

<script>
import { logout } from "@/api/common";
import { currUser } from "@/api/system/user";

export default {
  name: "Navcon",
  data() {
    return {
      collapsed: true,
      imgshow: require("../assets/img/show.png"),
      imgsq: require("../assets/img/sq.png"),
      user: {
        realName: "",
      },
      message: 12,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      if (this.$store.state.userInfo) {
        this.user = this.$store.state.userInfo;
      } else {
        currUser().then((data) => {
          this.user = data;
          this.$store.commit("userInfo", data);
        });
      }
    },
    handleExit() {
      this.$confirm("退出登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          logout()
            .then(() => {
              this.$store.commit("logout");
              this.$router.push({ path: "/login" });
            })
            .catch(() => {
              this.$message.error("退出失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消退出",
          });
        });
    },
    toggle(showtype) {
      this.collapsed = !showtype;
      this.$root.Bus.$emit("toggle", this.collapsed);
    },
    handleCaptureTicket() {
      // window.open('<scheme>://<host>:<port>/<path>?<query>')
      window.open("Ticket://open");
    },
  },
};
</script>
<style scoped>

.submenu {
  float: right;
}
.buttonimg {
  height: 60px;
  background-color: transparent;
  border: none;
}
.showimg {
  width: 26px;
  height: 26px;
  position: absolute;
  top: 17px;
  left: 17px;
}
.showimg:active {
  border: none;
}
.layoutRight {
  float: right;
  line-height: 58px;
}

.btn-info {
  display: inline-block;
}


.btn-info {
  position: relative;
}
.btn-info-tip {
  position: absolute;
  top: 10px;
  background-color: #ff464f;
}
.el-icon-bell {
  font-size: 20px;
  vertical-align: text-top;
}

</style>



// WEBPACK FOOTER //
// src/components/navcon.vue